__turbopack_context__.v({
  "empty": "bxDt2a_empty",
  "highlighted": "bxDt2a_highlighted",
  "input": "bxDt2a_input",
  "inputRow": "bxDt2a_inputRow",
  "palette": "bxDt2a_palette",
  "result": "bxDt2a_result",
  "resultIcon": "bxDt2a_resultIcon",
  "results": "bxDt2a_results",
  "searchIcon": "bxDt2a_searchIcon",
});
